import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";

export const arrowUp = (props) => {
  return <ArrowDropUpRoundedIcon {...props} />;
};
